import { createFileRoute } from '@tanstack/react-router'
import { savedDeviceSearchSchema } from '@/pages/profile/saved-devices/model/savedDeviceSearch'
import { SavedDevicesPage } from '@/pages/profile/saved-devices/ui/SavedDevicesPage'

export const Route = createFileRoute('/my-devices')({
  validateSearch: savedDeviceSearchSchema,
  component: SavedDevicesPage,
})
